import { useCallback, useEffect, useState } from 'react';
import { EventActions, getContentEmbedUIOrigin } from '../constants/contentEmbed';
const ContentEmbedUIOrigin = getContentEmbedUIOrigin();
export const useReceiveMessageFromContentEmbed = frameId => {
  const [isContentEmbedReady, setIsContentEmbedReady] = useState(false);
  const [contentHeight, setContentHeight] = useState(undefined);
  const handleInboundMessage = useCallback(inboundMessage => {
    if (!inboundMessage || inboundMessage.origin !== ContentEmbedUIOrigin) {
      return;
    }
    const messageDataBody = inboundMessage.data && inboundMessage.data.body;
    if (!messageDataBody || messageDataBody.id !== frameId) {
      return;
    }
    const {
      action
    } = messageDataBody;
    switch (action) {
      case EventActions.READY:
        {
          setIsContentEmbedReady(true);
          break;
        }
      case EventActions.SIZE_CHANGE:
        {
          const {
            height
          } = messageDataBody.payload;
          setContentHeight(height);
          break;
        }
      default:
        {
          break;
        }
    }
  }, [frameId]);
  useEffect(() => {
    window.addEventListener('message', handleInboundMessage);
    return () => {
      window.removeEventListener('message', handleInboundMessage);
    };
  }, [handleInboundMessage]);
  return {
    contentHeight,
    isContentEmbedReady
  };
};
export const usePostMessageToContentEmbed = ({
  html,
  isContentEmbedReady,
  targetWindow,
  frameId
}) => {
  const postMessageToContentEmbed = useCallback(outboundMessage => {
    if (!targetWindow) {
      return;
    }
    targetWindow.postMessage({
      body: Object.assign({}, outboundMessage, {
        id: frameId
      })
    }, ContentEmbedUIOrigin);
  }, [frameId, targetWindow]);
  useEffect(() => {
    if (isContentEmbedReady) {
      postMessageToContentEmbed({
        action: EventActions.SET_CONTENT,
        payload: {
          html
        }
      });
    }
  }, [html, isContentEmbedReady, postMessageToContentEmbed]);
};